app.controller('evidenceManagementDocumentsController', async function ($rootScope, $scope, $filter, safeApply, evidenceManagementService, systemService) {

  const currentYear = new Date().getFullYear();

  $scope.currentCountyName = 'collin'
  $scope.currentCountyCadCode = '043'

  $scope.loading = true

  $scope.tax_year = currentYear
  $scope.DocsValidated = 0
  $scope.DocType = 'closing_doc'
  $scope.closed = true
  $scope.userID = null
  $scope.showingUserID = false
  $scope.showHaveOffer = 0
  $scope.dataSaved = true

  $scope.useOnReport = false


  $scope.selectedIndex = -1

  // $scope.reportComplete = 0  
  // $scope.reviewed = false
  // $scope.showUncheckedPhotos = true
  // $scope.showUncheckedRepairs = true
  // $scope.showCreateReportOnly = -1
  // $scope.years = Array.from({ length: currentYear - 2025 + 1 }, (_, i) => 2025 + i);

  $scope.getAllDocuments = async function () {
    $scope.data = null
    safeApply($scope)
    $scope.loading = true;
    const obj = {
      cad_code: $scope.currentCountyCadCode,
      tax_year: $scope.tax_year,
      validated: $scope.DocsValidated,
      showHaveOffer: $scope.showHaveOffer,
      type: $scope.DocType,
      userID: $scope.userID
    }
    console.log('obj :>> ', obj);
    const data = await evidenceManagementService.getAllDocuments(obj)
    $scope.data = data.data.data
    console.log('data :>> ', data);
    $scope.loading = false;
    safeApply($scope)
  }

  $scope.setActiveItem = (index) => {
    if ($scope.dataSaved == false) {
      $scope.showSaveChangesModal()
      $scope.newSelectedItem = index
      return
    }
    $scope.newSelectedItem = null
    $scope.selectedIndex = index
    $scope.item = $scope.data[index]
    $scope.doc_url = $scope.item.doc_url
    console.log('$scope.doc_url :>> ', $scope.doc_url);
    safeApply($scope)
  }

  $scope.setDocumentsValidated = (validated) => {
    $scope.DocsValidated = validated
    $scope.getAllDocuments()
  }

  $scope.setHaveOffer = (showHaveOffer) => {
    $scope.showHaveOffer = showHaveOffer
    $scope.selectedIndex = -1
    $scope.getAllDocuments()
  }

  $scope.findUserID = () => {
    if ($scope.showingUserID) {
      $scope.showingUserID = false
      $scope.userID = null
      $scope.getAllDocuments()
      return
    } else {
      $scope.showingUserID = true
    }
    $scope.selectedIndex = -1
    $scope.getAllDocuments()
  }

  $scope.setCounty = (county) => {
    if (!county) return
    $scope.currentCountyName = county.name
    $scope.currentCountyCadCode = county.cad_code
    $scope.getAllDocuments()
  }

  $scope.refreshQuery = () => {
    $scope.selectedIndex = -1
    $scope.getAllDocuments()
  }

  $scope.saveItem = async () => {
    const item = $scope.item
    const obj = {
      doc_id: item.doc_id,
      value: item.value,
      doc_date: item.doc_date,
      reviewed_by: item.verified_by,
      verified: (item.verified ? 1 : 0),
      use_on_report: (item.use_on_report ? 1 : 0),
      verified_date: new Date().toISOString().slice(0, 10)
    }
    const saveDocumentsRecordResults = await evidenceManagementService.saveDocumentsRecord(obj)
    if (saveDocumentsRecordResults.data.success) {
      toastr.success('Data Saved')
    } else {
      toastr.error('Error Saving Data')
    }
    $scope.closeSaveChangesModal()
    $scope.dataSaved = true
    if ($scope.newSelectedItem != null) {
      $scope.setActiveItem($scope.newSelectedItem)
    }
    safeApply($scope)
  }

  $scope.updateReviewedBy = () => {
    const p = $scope.item
    p.verified = !p.verified
    if (p.verified) {
      p.verified_by = $rootScope.user_info.initials
      // p.reviewed_on = new Date()
    } else {
      p.verified_by = ''
      // p.reviewed_on = null
    }
    $scope.dataSaved = false
    safeApply($scope)
  }

  $scope.updateCreateReport = (value) => {
    console.log("Set to " + value);
    const p = $scope.item
    p.create_report = value
    if (p.create_report == 1) {
      p.create_report_by = $rootScope.user_info.initials
    } else {
      p.create_report_by = ''
    }
    $scope.dataSaved = false
    safeApply($scope)
  }

  $scope.showFullsizeImage = (url) => {
    const modalID = '#largePhotoModal'
    $scope.fullsizeImage = url.url.path
    $scope.fullsizeImageDescription = url.description
    $(modalID).modal('show')
    safeApply($scope)
    console.log($scope.item.photos);
    $scope.closeFullsizeImage = () => {
      $(modalID).modal('hide')
    }
  }

  $scope.showSaveChangesModal = () => {
    const modalID = '#saveChangesModal'
    $(modalID).modal('show')
    safeApply($scope)
  }
  $scope.closeSaveChangesModal = () => {
    const modalID = '#saveChangesModal'
    $(modalID).modal('hide')
  }

  $scope.showAddNotesModal = () => {
    console.log('item :>> ', $scope.item);
    const modalID = '#addNotesModal'
    $(modalID).modal('show')
    $(modalID).on('shown.bs.modal', function (event) {
      document.getElementById("notes").focus();
    })
    $scope.dataSaved = false
    safeApply($scope)

    $scope.closeAddNotesModal = () => {
      $(modalID).modal('hide')
    }
  }

  $scope.updateUseOnReport = (p) => {
    $scope.item.use_on_report = p
    $scope.dataSaved = false
    safeApply($scope)
  }

  $scope.updateItemValue = (value) => {
    $scope.item.value = value
    $scope.dataSaved = false
    safeApply($scope)
  }

  $scope.updateItemDocDate = (value) => {
    $scope.item.doc_date = value
    $scope.dataSaved = false
    safeApply($scope)
  }

  $scope.setShowInReport = (p) => {
    p.use_in_report = !p.use_in_report
    $scope.dataSaved = false
    safeApply($scope)
  }

  $scope.updateImportant = () => {
    const p = $scope.item
    p.important = !p.important
    $scope.dataSaved = false
    safeApply($scope)
  }

  $scope.setDataUnsaved = () => {
    $scope.dataSaved = false
  }

  init()
  async function init() {
    let countyListResults = await systemService.functionCall({ type: "countyList", active_only: true })
    if (countyListResults.data.success) {
      $scope.countyList = countyListResults.data.data
      console.log('$scope.countyList :>> ', $scope.countyList);
    } else {
      console.log("*** System Error ***")
    }
    $scope.getAllDocuments()
  }


  // Filters |---------------------------------------------------
  $scope.photoLocationFilter = (item) => {
    return item.photos.length > 0
  }

  $scope.photoFilter = (item) => {
    if (item) {
      return (item.use_in_report) || ($scope.showUncheckedPhotos == true ? 0 : 1) == item.use_in_report
    } else {
      return false
    }
  }

  $scope.repairFilter = (item) => {
    return (item.use_in_report == true) || $scope.showUncheckedRepairs !== item.use_in_report

  }

})